<template>
  <div
    id="tavolo-cerchio"
    :class="[
      'da_' + _.max([_.size(asta_squadre), 1]),
      'cerchio',
      tavoloSize,
      'squadre' + _.capitalize(squadreSize),
    ]"
  >
    <div id="cerchio">
      <!-- <li > -->
        <squadra-tavolo
          v-for="sq in asta_squadre_array"
          :key="sq.id"
          :id="sq.id"
          :size="squadreSize"
        ></squadra-tavolo>
      <!-- </li> -->
    </div>
    <calciatore-su-tavolo
      :id="asta_round.calciatoreInAsta"
      v-if="asta_round.calciatoreInAsta"
    ></calciatore-su-tavolo>
  </div>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";
import SquadraTavolo from "./common/SquadraTavolo";
import Calciatore from "./common/Calciatore";
import AstaLog from "./common/AstaLog";
import CalciatoreBattuto from "./common/CalciatoreBattuto";
import CalciatoreSuTavolo from "./common/CalciatoreSuTavolo";

import mixins from "../js/mixins";

export default {
  name: "asta-tavolo-cerchio",
  mixins: [mixins],
  components: {
    SquadraTavolo,
    Calciatore,
    CalciatoreBattuto,
    CalciatoreSuTavolo,
  },
  computed: {
    ...Vuex.mapGetters(["asta_squadre_array", "tavoloSize", "squadreSize"]),
  },
  mounted() {
    console.log("--> AstaTavoloCerchio ready.");
  },
  destroyed() {
    console.log("<-- AstaTavoloCerchio destroyed.");
  },
};
</script>
<style lang="scss" scoped>
@use "sass:map";
@import "../main.scss";

#tavolo-cerchio {
  position: relative;
  margin: 27px auto 0px;
  #cerchio {
    background-image: repeating-linear-gradient(
      -45deg,
      #c1e62b,
      #c1e62b 25px,
      #9fca0d 25px,
      #9fca0d 50px
    );
    background-color: #c1e62b;
    background-repeat: repeat;
    box-shadow: 0 0 40px 0px rgba(0, 0, 0, 0.2);
  }
}

@mixin on-circle($item-count, $circle-size, $item-width, $item-height) {
  position: relative;
  border-radius: 50%;
  padding: 0;
  list-style: none;

  > * {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -(calc($item-width / 2)) !important;
    margin-top: -(calc($item-height / 2)) !important;
    z-index: 1;

    &:hover {
      z-index: 100;
    }

    $angle: calc(360 / $item-count);
    $rot: 0;
    $adjust: 5;
    @for $i from 1 through $item-count {
      $rot-adjusted: $rot;
      @if $rot > 0 {
        @if $rot < 90 {
          $rot-adjusted: $rot - $adjust;
        }
      }
      @if $rot > 90 {
        @if $rot < 180 {
          $rot-adjusted: $rot + $adjust;
        }
      }
      @if $rot > 180 {
        @if $rot < 270 {
          $rot-adjusted: $rot - $adjust;
        }
      }
      @if $rot > 270 {
        @if $rot < 360 {
          $rot-adjusted: $rot + $adjust;
        }
      }
      &:nth-of-type(#{$i}) {
        transform: rotate($rot-adjusted * 1deg)
          translate(calc($circle-size / 2))
          rotate($rot-adjusted * -1deg);
      }
      $rot: $rot + $angle;
    }
  }
}

// Tavolo rotondo
$tavolo-diameters: (
  small: 250px,
  medium: 350px,
  large: 430px,
);

$squadra-classes: ("squadreSmall", "squadreMedium", "squadreLarge");

$squadra-widths: (
  squadreSmall: 88px,
  squadreMedium: 120px,
  squadreLarge: 140px,
);

$squadra-heights: (
  squadreSmall: 50px,
  squadreMedium: 60px,
  squadreLarge: 70px,
);

@each $class-name1, $tavolo-diameter in $tavolo-diameters {
  @each $squadra-class in $squadra-classes {
    $squadra-width: map.get($squadra-widths, $squadra-class);
    $squadra-height: map.get($squadra-heights, $squadra-class);

    #tavolo-cerchio.#{$class-name1},
    #tavolo-cerchio.#{$class-name1} #cerchio {
      width: $tavolo-diameter;
      height: $tavolo-diameter;
    }

    @for $i from 1 through 24 {
      #tavolo-cerchio.#{$class-name1}.#{$squadra-class}.da_#{$i} #cerchio {
        @include on-circle(
          $item-count: $i,
          $circle-size: $tavolo-diameter,
          $item-width: $squadra-width,
          $item-height: $squadra-height
        );
      }
    }
  }
}
</style>
